import {
  HELP_BEST_PRACTICES_TIPS_TRICKS_URL,
  HELP_PRINT_STORE_URL
} from '@dtx-company/true-common/src/constants/help'
import {
  PredesignedFlowtagProps,
  ProductTypeName,
  SelectedBillingOptionsProps,
  SurveyCardDataProps,
  WhyPurchaseInfoDataProps
} from '../types/print-store.types'
import { SelectOption } from '@dtx-company/shared-components/src'
import {
  printProductItemFallback,
  printStoreGenericCircleStickers,
  printStoreGenericFloorSticker,
  printStoreGenericWallSticker
} from './assets'

export const SURVEY_CARD_DATA: Readonly<SurveyCardDataProps> = {
  id: 'survey-link',
  name: 'More products coming soon!',
  description: 'Let us know what you’d like to see.',
  actionButtonLabel: 'Take our survey',
  imageUrl: printProductItemFallback,
  link: 'https://docs.google.com/forms/d/e/1FAIpQLScmzFgoyQbtcHp_35sbFaK8FXhMA3VEpwQklRIudGT2g6JJ4A/viewform?usp=sf_link'
}

export const WHY_PURCHASE_INFO_DATA: Readonly<WhyPurchaseInfoDataProps[]> = [
  {
    iconSrc: '/icons/statistics-black.svg',
    title: 'Grow your business',
    description: 'Connect with more customers, drive sales, and increase brand loyalty.'
  },
  {
    iconSrc: '/icons/infinity.svg',
    title: 'Flowcodes last forever',
    description: 'With unlimited scans, the Flowcode you print will never stop scanning.'
  },
  {
    iconSrc: '/icons/actionable.svg',
    title: 'Update your scan destination',
    description:
      'Print your Flowcode once and update the destination or set timing rules to send your audience where you want, when you want.'
  }
]

export const WHY_PURCHASE_INFO_DATA_ALT: Readonly<WhyPurchaseInfoDataProps[]> = [
  {
    iconSrc: '/icons/verified-checkmark-outline.svg',
    title: 'Premium quality guaranteed',
    description: 'Our products are made with the most durable materials that are made to last.'
  },
  {
    iconSrc: '/icons/infinity-1.svg',
    title: 'Flowcodes last forever',
    description: 'With unlimited scans, the Flowcode you print will never expire.'
  }
]

export const PRODUCT_DETAILS_DESCRIPTION_DELIMITER = /\n/
export const CURRENT_DAY = 1
export const DEFAULT_BILLING_CURRENCY_SYMBOL = '$'
export const DEFAULT_BILLING_CURRENCY_CODE = 'USD'
export const CHECKOUT_MODAL_BEST_PRACTICES_LINK = HELP_BEST_PRACTICES_TIPS_TRICKS_URL
export const INVALID_NON_WORKING_DAYS_LENGTH = 7 // [0, 1, 2, 3, 4, 5, 6] SUN -> SAT
export const PRINT_STORE_BEST_PRACTICES_URL = HELP_PRINT_STORE_URL
export const NON_WORKING_WEEKEND_DAYS = [0, 6]

const US_COUNTRY_CODE: SelectOption = {
  label: 'United States',
  value: 'US'
}

export const DEFAULT_INITIAL_BILLING_OPTIONS: Readonly<SelectedBillingOptionsProps> = {
  quantity: 0,
  savedValue: 0,
  country: { ...US_COUNTRY_CODE },
  shippingOptionId: '',
  // TODO: remove shippingCost from this object
  shippingCost: 0,
  handlingOptionId: '',
  unitAmount: 0,
  itemsSubTotal: '0',
  businessName: '',
  itemsSubTotalDiscounted: 0
}

export enum MONTHS {
  Jan,
  Feb,
  Mar,
  Apr,
  May,
  Jun,
  Jul,
  Aug,
  Sep,
  Oct,
  Nov,
  Dec
}

export const PRINT_STORE_LANDING_PAGE_GRAPHICS = [
  printStoreGenericWallSticker,
  printStoreGenericCircleStickers,
  printStoreGenericFloorSticker
]

export const PREDESIGNED_FLOWTAG_PRODUCT_DATA: Readonly<PredesignedFlowtagProps>[] = [
  {
    id: 'flowtag_001',
    name: 'Pre-designed Flowtag Scan Only',
    link: 'https://getflowtag.com/products/flowtag?utm_source=flowcode&utm_medium=printstore&utm_campaign=scan+only',
    imageUrl:
      'https://cdn.flowcode.com/prodassets/printstore/product_image_assets/predesigned_flowtag_001.png',
    actionButtonLabel: 'Order Now',
    productType: ProductTypeName.PREDESIGN_FLOWTAGS
  },
  {
    id: 'flowtag_002',
    name: 'Pre-designed Flowtag Scan + Tap',
    link: 'https://getflowtag.com/products/flowtag?utm_source=flowcode&utm_medium=printstore&utm_campaign=scan+and+tap',
    imageUrl:
      'https://cdn.flowcode.com/prodassets/printstore/product_image_assets/predesigned_flowtag_002.png',
    actionButtonLabel: 'Order Now',
    productType: ProductTypeName.PREDESIGN_FLOWTAGS
  }
]
